"use client";

import { usePathname } from "next/navigation";

// Faja superior del panel para saber QUÉ instancia estás usando (dev/stage/producción) o para
// anuncios puntuales (p. ej. "Feliz Navidad"). Llegan como props desde el layout (server), que los
// lee de las env APP_FAJA (texto libre) y APP_FAJA_TONO (color de fondo en hex, p. ej. "#020205").
// Regla única: sin texto → no se muestra. Se oculta en el WebView del socio (/app/*), igual que la navbar.

const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
const FONDO_POR_DEFECTO = "#374151"; // gris neutro si el hex es inválido o falta

// Color de texto legible (blanco/negro) según la luminancia del fondo.
function textoLegible(hex: string): string {
  let h = hex.slice(1);
  if (h.length === 3) h = h.replace(/./g, (c) => c + c);
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  // Luminancia relativa aproximada (0 oscuro … 255 claro).
  const lum = 0.299 * r + 0.587 * g + 0.114 * b;
  return lum < 140 ? "#ffffff" : "#000000";
}

export function Faja({ texto, tono }: { texto?: string; tono?: string }) {
  const pathname = usePathname();
  if (!texto || !texto.trim()) return null;
  if (pathname?.startsWith("/app")) return null;

  const t = (tono ?? "").trim();
  const fondo = HEX.test(t) ? t : FONDO_POR_DEFECTO;
  return (
    <div
      className="w-full px-4 py-1 text-center text-sm font-semibold tracking-wide"
      style={{ backgroundColor: fondo, color: textoLegible(fondo) }}
      role="status"
    >
      {texto}
    </div>
  );
}
